import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export const useColumnCount = (ref: RefObject<HTMLElement | null>) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = (width: number) =>
      setCount(Math.max(0, Math.floor((width - 1) / 2)));
    update(el.clientWidth);
    const ro = new ResizeObserver((entries) =>
      update(entries[0].contentRect.width)
    );
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);

  return count;
};
